import { useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  error,
  success,
} from "../../../../../components/alertMessagesHandler/alert";
import CButton from "../../../../../components/buttons/Button";
import CRadiobutton from "../../../../../components/inputBoxes/radioButton";
import CTextField from "../../../../../components/inputBoxes/text-input";
import CTextAreaField from "../../../../../components/inputBoxes/textArea-input";
import { LoadingContext } from "../../../../../context/loadingContext";
import {
  SignUpThemeHooks,
  SignUpThemeUpdateHooks,
  getCategoryList,
} from "../../hooks/useSignup";

const RegThemePage = (props) => {
  const { setLoading } = useContext(LoadingContext);
  const dispatch = useDispatch();
  const { portal_id } = useParams();
  const ThemeReducer = useSelector((state) => state.BusinessThemeReducer);
  const [FieldsValue, setFieldsValue] = useState();
  const [categoryList, setCategoryList] = useState([]);
  useEffect(() => {
    // Get category list from db

    (async () => {
      const cateoryHook = await getCategoryList();
      setCategoryList([]);
      const tempCategory = [];
      cateoryHook.data.map((data) => {
        tempCategory.push({
          id: data.name.replaceAll(" ", "_"),
          value: data.mpc_id,
          label: data.name,
        });
      });
      setCategoryList(tempCategory);
      setButtonAutoPopulate();
    })();
  }, [props]);

  // Autofill the checked value

  const setButtonAutoPopulate = () => {
    switch (
    props.AutoFillDataProp.data_portal_infos &&
      props.AutoFillDataProp.data_portal_infos[0]["data_pub_siteinfos"][0]
      ? props.AutoFillDataProp.data_portal_infos[0]["data_pub_siteinfos"][0][
      "category"
      ]
      : ""
    ) {
      case 1:
        document.getElementById("Health_&_Wellness").checked = true;
        break;
      case 2:
        document.getElementById("Medical").checked = true;
        break;
      case 3:
        document.getElementById("Clinical_Research").checked = true;
        break;
      case 4:
        document.getElementById("Health_economics_and_finance").checked = true;
        break;
    }
  };

  // Theme data register in registration page using SignUpThemeHooks

  const themeHandle = async () => {
    setLoading(true);
    const res = await SignUpThemeHooks(FieldsValue);
    setLoading(false);
    if (res.status === 200) {
      dispatch({ type: "BUSINESS_THEME_DONE" });
      document.getElementById("pills-popularity-tab").click();
      success("Theme Data created successfully");
    } else {
      error(res.message);
    }
  };

  // Update theme page data using SignUpThemeUpdateHooks

  const ThemeDataUpdate = async () => {
    setLoading(true);
    const data = {
      mpi_id: Number(portal_id),
      updateData: FieldsValue,
    };
    const result = await SignUpThemeUpdateHooks(data);
    setLoading(false);
    if (result.status === 200) {
      document.getElementById("pills-popularity-tab").click();
      success("Theme Data Updated successfully");
    } else {
      error(result.message);
    }
  };

  const HandleFieldsValue = (key, value) => {
    setFieldsValue({ ...FieldsValue, [key]: value });
  };

  const submit = (event) => {
    event.preventDefault();

    if (props.regPage === "update-new-business") {
      ThemeDataUpdate();
    } else {
      if (ThemeReducer === 0) themeHandle();
      else document.getElementById("pills-popularity-tab").click();
    }
  };

  return (
    <>
      <div className="container">
        <div className="row mb-4">
          <div className="col-md-3 col-sm-12"></div>
          <div className="col-md-4 col-sm-12">
            <form onSubmit={submit}>
              <CRadiobutton
                labelName={"Category"}
                name={"category"}
                required={true}
                customClassDiv={"mb-4 text-dark"}
                isInline={true}
                choiceListArray={categoryList}
                customClassLabel={"mb-3"}
                functionName={(name, Category) =>
                  HandleFieldsValue(name, Category)
                }
              />
              <CTextField
                labelName={"Keywords"}
                value={
                  props.AutoFillDataProp.data_portal_infos &&
                    props.AutoFillDataProp.data_portal_infos[0][
                    "data_pub_siteinfos"
                    ][0]
                    ? props.AutoFillDataProp.data_portal_infos[0][
                    "data_pub_siteinfos"
                    ][0]["tags"]
                    : ""
                }
                name={"tags"}
                customClassDiv={"mb-4 text-dark"}
                inputMessage={"Separate keywords with a comma"}
                customClassInput={"bg-primary-soft"}
                functionName={(name, Tags) => HandleFieldsValue(name, Tags)}
              />
              <CTextField
                labelName={"Parent Topics"}
                name={"parent_topic"}
                customClassDiv={"mb-4 text-dark"}
                customClassInput={"bg-primary-soft"}
                value={
                  props.AutoFillDataProp.data_portal_infos &&
                    props.AutoFillDataProp.data_portal_infos[0][
                    "data_pub_siteinfos"
                    ][0]
                    ? props.AutoFillDataProp.data_portal_infos[0][
                    "data_pub_siteinfos"
                    ][0]["parent_topic"]
                    : ""
                }
                inputMessage={"Separate topics with a comma"}
                functionName={(name, parent_topic) =>
                  HandleFieldsValue(name, parent_topic)
                }
              />
              <CTextAreaField
                labelName={"Description"}
                name={"description"}
                value={
                  props.AutoFillDataProp.data_portal_infos &&
                    props.AutoFillDataProp.data_portal_infos[0][
                    "data_pub_siteinfos"
                    ][0]
                    ? props.AutoFillDataProp.data_portal_infos[0][
                    "data_pub_siteinfos"
                    ][0]["description"]
                    : ""
                }
                required={true}
                rowsTextArea={6}
                customClassDiv={"mb-5 text-dark"}
                customClassInput={"bg-primary-soft"}
                functionName={(name, Description) =>
                  HandleFieldsValue(name, Description)
                }
              />
              <CButton
                btnClassesDiv={"text-center"}
                btnClasses={"btn px-4 fw-bold text-white formbutton"}
                IsOutline={false}
                innertext={"Next"}
                btnCustomStyle={{
                  backgroundColor: "#044389",
                }}
              />
            </form>
          </div>
          <div className="col-md-5 col-sm-12"></div>
        </div>
      </div>
    </>
  );
};

export default RegThemePage;
